import { BreakpointConfig } from '@todesktop/shared';
import {
  formatBreakpoint,
  listBreakpointDefinitions,
  parseBreakpointList,
} from '../../../utilities/introspectionBreakpoints';

export interface BreakpointResolution {
  breakpoints: BreakpointConfig[];
  warnings: string[];
  expansions: Array<{ input: string; outputs: BreakpointConfig[] }>;
}

export function resolveBreakpointInput(
  input: string,
): BreakpointResolution | { error: string } {
  const result = parseBreakpointList(input);

  if (result.errors.length > 0) {
    return { error: result.errors.join('\n') };
  }

  return {
    breakpoints: result.breakpoints,
    warnings: result.warnings,
    expansions: result.expansions,
  };
}

export function formatBreakpointCatalog(): string {
  const definitions = listBreakpointDefinitions();
  const lines: string[] = [];
  lines.push('Supported breakpoints:');
  for (const definition of definitions) {
    lines.push(
      `  - ${definition.value} — ${definition.description} (${
        definition.config.type === 'phase'
          ? 'phase'
          : `${definition.config.id} ${definition.config.position}`
      })`,
    );
  }
  return lines.join('\n');
}

export function formatResolvedQueueMessage(
  breakpoints: BreakpointConfig[],
  warnings: string[],
  expansions: Array<{ input: string; outputs: BreakpointConfig[] }>,
): string[] {
  const lines: string[] = [];

  if (!breakpoints.length) {
    lines.push(
      'Breakpoints were requested but no valid entries were provided. Build will continue without pause points.',
    );
    return lines;
  }

  lines.push(`Breakpoints enabled:`);
  breakpoints.forEach((breakpoint, index) => {
    lines.push(`  ${index + 1}. ${formatBreakpoint(breakpoint)}`);
  });

  if (expansions.length) {
    lines.push('');
    for (const expansion of expansions) {
      lines.push(
        `  ℹ "${expansion.input}" expands to ${expansion.outputs
          .map((bp) => formatBreakpoint(bp))
          .join(', ')}`,
      );
    }
  }

  if (warnings.length) {
    lines.push('');
    lines.push(...warnings.map((warning) => `  ! ${warning}`));
  }

  return lines;
}
